<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  min-height: 100%;
  color: #333;
}

/* 移动端适配 */
@media (max-width: 375px) {
  html {
    font-size: 14px;
  }
}

@media (min-width: 376px) and (max-width: 414px) {
  html {
    font-size: 15px;
  }
}

@media (min-width: 415px) {
  html {
    font-size: 16px;
  }

  #app {
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0,0,0,0.1);
  }
}

/* 禁用文本选择（移动端体验更好） */
noscript, noscript * {
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

button {
  -webkit-tap-highlight-color: rgba(0,0,0,0.1);
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 2px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue